import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { Subject } from 'rxjs/Subject';

import { MessageService } from '@services/helpers/message-service/message.service';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';

@Component({
	selector: 'choose-files-modal',
	template: require('./choose-files-modal.html')
})
export class ChooseFilesModalComponent implements OnInit, OnDestroy {
	unsubscribe: Subject<void> = new Subject<void>();

	files: any;
	checkedFiles: any = {};
	maxMb: number;
	maxSize: number;

	constructor(
		private viewCtrl: ViewController,
		private filesDataService: FileUploadDataProvider,
		private filesService: FileUploadServiceProvider,
		private messageService: MessageService
	) {
		this.maxSize = this.filesService.maxSize;
		this.maxMb = this.filesService.maxAttachment;
	}

	addAttachment() {
		this.checkedFiles = this.files.filter(file => file.checked);

		if (this.checkedFiles && this.checkedFiles.length) {
			const size = this.filesService.getTotalSize(this.checkedFiles);

			if (size > this.maxMb) {
				this.messageService.showToaster('w_0', 'attachments');
				return;
			}
		}

		this.filesDataService.setCheckedFiles(this.checkedFiles);
		this.dismiss();
		this.files = this.files.map(file => (file.checked = ''));
	}

	dismiss(data?) {
		this.viewCtrl.dismiss(data);
	}

	ngOnInit() {
		this.filesDataService.filesObservable
			.takeUntil(this.unsubscribe)
			.subscribe(value => {
				this.files = [...value];
			});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./mobile/src/components/files/modals/choose-files-modal/choose-files-modal.ts